module.exports = __webpack_public_path__ + "static/fowf-team-web1-755ffca05b84d31b1b01d830edd6c0f6.jpg";